import styled from 'styled-components';

export const IconContainer = styled.div<{ collapsed: boolean }>`
  transform: ${props => props.collapsed && 'rotate(180deg)'};
`;
